export const linksligas = [
    {
        "nombre" : "Ligas de Interes",
        "link" : "/Ligas_Interes",
        "submenu" : [
            {
                "subMenuNombre" : "Programa de Apoyo al Empleo",
                "subMenuUrl" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/trabajo/dir3/pdf/programa_apoyo_empleo_2026.pdf"
            },{
                "subMenuNombre" : "Ligas de Interes",
                "subMenuUrl" : "/Ligas_Interes"
            },
            {
                "subMenuNombre" : "Reglas de Operación",
                "subMenuUrl" : "/Reglas"
            },
            {
                "subMenuNombre" : "Justicia Laboral",
                "subMenuUrl" : "https://justicialaboral.hidalgo.gob.mx/"
            },{
                "subMenuNombre" : "Sistema Alterno de Inspección Laboral (Sail)",
                "subMenuUrl" : "/Sail"
            }
        ]
    }
]